import { render, staticRenderFns } from "./DashboardStats.vue?vue&type=template&id=9d5999ce&"
import script from "./DashboardStats.vue?vue&type=script&lang=js&"
export * from "./DashboardStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Abdelaziz\\Documents\\depot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d5999ce')) {
      api.createRecord('9d5999ce', component.options)
    } else {
      api.reload('9d5999ce', component.options)
    }
    module.hot.accept("./DashboardStats.vue?vue&type=template&id=9d5999ce&", function () {
      api.rerender('9d5999ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/DashboardStats.vue"
export default component.exports